import React, { useEffect, createElement } from 'react';
import { CheckCircle2, XCircle, ShieldCheck, Package, BookOpen, Wrench, Paintbrush, Layers, Link as LinkIcon, MessageCircle, FileText, Calculator, CreditCard, Lock } from 'lucide-react';
import { CTAButton } from './components/CTAButton';
import { CountdownTimer } from './components/CountdownTimer';
import { FAQItem } from './components/FAQItem';
import { TestimonialCard } from './components/TestimonialCard';
export function App() {
  useEffect(() => {
    // Meta Pixel
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '791760300589507');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=791760300589507&ev=PageView&noscript=1';
    noscript.appendChild(img);
    document.body.appendChild(noscript);
    return () => {
      document.head.removeChild(script);
      document.body.removeChild(noscript);
    };
  }, []);
  const scrollToPricing = () => {
    document.getElementById('oferta')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="min-h-screen bg-[#0A0A0A] text-white font-sans selection:bg-[#D4A843] selection:text-[#0A0A0A]" data-id="element-0">
      {/* SECCIÓN 1 — BARRA SUPERIOR DE URGENCIA */}
      <div className="fixed top-0 left-0 right-0 bg-[#FF8C00] text-[#0A0A0A] z-50 py-1 px-2 shadow-lg" data-id="element-1">
        <div className="max-w-6xl mx-auto flex flex-wrap items-center justify-center gap-1 sm:gap-2 text-xs sm:text-sm font-bold text-center" data-id="element-2">
          <span className="flex items-center gap-1" data-id="element-3">
            🔴ATENCIÓN: Esta oferta de lanzamiento vence en:
          </span>
          <CountdownTimer compact className="bg-[#0A0A0A] text-[#FF8C00] px-2 py-0.5 rounded text-xs" data-id="element-4" />
          <span className="hidden sm:inline" data-id="element-5">
            Precio especial solo por tiempo limitado
          </span>
        </div>
      </div>

      {/* SECCIÓN 2 — HERO SECTION */}
      <section className="pt-20 pb-16 md:pt-24 md:pb-24 px-4 bg-gradient-to-b from-[#111111] to-[#0A0A0A]" data-id="element-6">
        <div className="max-w-4xl mx-auto text-center" data-id="element-7">
          <h1 className="text-4xl md:text-6xl font-extrabold text-[#D4A843] leading-tight mb-3 tracking-tight" data-id="element-8">
            ¿Y si el mueble que estás por tirar
            <br className="hidden md:block" data-id="element-9" /> pudiera pagarte el alquiler del
            mes?
          </h1>
          <p className="text-lg md:text-2xl text-[#C8B89A] mb-5 max-w-3xl mx-auto leading-relaxed" data-id="element-10">
            Descubrí el método exacto para transformar pallets descartados en
            muebles de diseño que se venden solos por WhatsApp — sin experiencia
            previa, sin taller propio, sin inversión de riesgo.
          </p>

          {/* Product Mockup Image */}
          <div className="w-full max-w-2xl mx-auto mb-10 rounded-xl overflow-hidden shadow-2xl" data-id="element-11">
            <img src="https://cdn.magicpatterns.com/uploads/gHBp1HmWiYKXpwAyusRxdv/hf_20260326_160414_344a2650-9fad-47c2-8c12-c91aae7bcd34.png" alt="El Método Madera Cero - Pack Completo con todos los tomos" className="w-full h-auto" data-id="element-12" />
          </div>

          <div className="flex justify-center" data-id="element-13">
            <CTAButton onClick={scrollToPricing} className="text-sm md:text-base py-2 px-4" data-id="element-14">
              🔨 QUIERO EMPEZAR HOY MISMO →
            </CTAButton>
          </div>
        </div>
      </section>

      {/* SECCIÓN 3 — IDENTIFICACIÓN CON EL DOLOR */}
      <section className="py-16 md:py-24 px-4 bg-[#111111] border-y border-[#2A1F0A]" data-id="element-15">
        <div className="max-w-4xl mx-auto" data-id="element-16">
          <h2 className="text-2xl md:text-3xl font-bold text-center text-white mb-12" data-id="element-17">
            Leé esto si alguna vez pensaste alguna de estas cosas:
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-18">
            {['Me gustaría hacer algo con las manos pero no sé por dónde empezar...', 'Vi muebles de pallet en Instagram y parecen fáciles, pero cuando lo intento me queda horrible...', 'Necesito un ingreso extra pero no tengo plata para invertir en materiales caros...', 'Tengo ganas de emprender pero no tengo un oficio ni una habilidad que vender...', 'Trabajo todo el día para otro y al final del mes no me sobra nada...', 'Vi videos de YouTube pero son todos en inglés o te saltean los pasos importantes...'].map((pain, idx) => <div key={idx} className="flex items-start gap-4 bg-[#1C1208] p-6 rounded-lg border border-[#2A1F0A]" data-id="element-19">
                <XCircle className="w-6 h-6 text-[#FF8C00] flex-shrink-0 mt-1" data-id="element-20" />
                <p className="text-[#C8B89A] text-lg leading-relaxed" data-id="element-21">
                  "{pain}"
                </p>
              </div>)}
          </div>

          <div className="bg-[#1A1407] p-8 rounded-xl border border-[#D4A843]/30 text-center max-w-3xl mx-auto" data-id="element-22">
            <p className="text-xl text-white leading-relaxed" data-id="element-23">
              Si te identificaste con al menos UNO de esos puntos, lo que estás
              por leer va a cambiar tu situación.{' '}
              <span className="text-[#D4A843] font-bold" data-id="element-24">
                No porque sea magia.
              </span>{' '}
              Sino porque es un sistema que ya funciona para cientos de personas
              en toda Latinoamérica que empezaron exactamente desde donde estás
              vos hoy.
            </p>
          </div>
        </div>
      </section>

      {/* SECCIÓN 4 — LA HISTORIA / ORIGEN */}
      <section className="py-16 md:py-24 px-4 bg-[#1A1407] relative overflow-hidden" data-id="element-25">
        {/* Background carpenter image - full section with dark overlay */}
        <div className="absolute inset-0" data-id="element-26">
          <img src="https://cdn.magicpatterns.com/uploads/iUNzvhzR21HWSv4jdiNSzD/carp.jpg" alt="Carpintero trabajando con madera" className="w-full h-full object-cover" data-id="element-27" />
          <div className="absolute inset-0 bg-[#1A1407]/85" data-id="element-28"></div>
        </div>

        <div className="max-w-3xl mx-auto relative z-10" data-id="element-29">
          <div className="text-center mb-10" data-id="element-30">
            <h2 className="text-3xl md:text-4xl font-bold text-[#D4A843] mb-4 uppercase tracking-wider" data-id="element-31">
              ¿Cómo nació El Método Madera Cero?
            </h2>
            <div className="h-1 w-24 bg-[#D4A843] mx-auto rounded-full" data-id="element-32"></div>
          </div>

          <div className="space-y-6 text-lg leading-relaxed bg-[#0A0A0A]/70 p-8 rounded-xl backdrop-blur-sm border border-[#2A1F0A]" data-id="element-33">
            <p className="text-white font-medium drop-shadow-[0_2px_4px_rgba(0,0,0,0.8)]" data-id="element-34">
              Todo empezó con un pallet tirado en la vereda.
            </p>
            <p className="text-white drop-shadow-[0_2px_4px_rgba(0,0,0,0.8)]" data-id="element-35">
              Hace unos años, como muchos de ustedes, estaba buscando una
              salida. Un ingreso propio. Algo que no dependiera de que alguien
              más me diera trabajo.
            </p>
            <p className="text-white drop-shadow-[0_2px_4px_rgba(0,0,0,0.8)]" data-id="element-36">
              Un día vi un pallet roto tirado afuera de un local de
              electrodomésticos. Lo cargué en el auto. No tenía ni idea de qué
              iba a hacer con él.
            </p>
            <p className="text-white drop-shadow-[0_2px_4px_rgba(0,0,0,0.8)]" data-id="element-37">
              Esa noche empecé a desarmarlo. Me corté tres veces. Quebré dos
              tablas. Armé algo que honestamente parecía una balsa náufraga, no
              una mesa.
            </p>
            <p className="text-[#D4A843] font-bold text-xl drop-shadow-[0_2px_4px_rgba(0,0,0,0.8)]" data-id="element-38">
              Pero no me rendí.
            </p>
            <p className="text-white drop-shadow-[0_2px_4px_rgba(0,0,0,0.8)]" data-id="element-39">
              Empecé a estudiar. A experimentar. A entender qué madera sirve y
              cuál no. Qué herramientas realmente necesitás y cuáles son pérdida
              de tiempo y plata. Cómo lijar, teñir y sellar para que quede un
              acabado que nadie creería que es pallet.
            </p>
            <p className="text-white drop-shadow-[0_2px_4px_rgba(0,0,0,0.8)]" data-id="element-40">
              Después de meses de prueba y error, armé mi primera mesa que me
              dio vergüenza mostrar. Después la segunda, que me dio vergüenza
              pero la mostré.
            </p>
            <p className="text-2xl text-[#D4A843] font-bold py-6 text-center border-y-2 border-[#D4A843] my-8 bg-[#0A0A0A]/90 rounded-lg drop-shadow-[0_4px_8px_rgba(0,0,0,0.9)]" data-id="element-41">
              Y la tercera la vendí.
              <br data-id="element-42" />
              $370 USD por WhatsApp.
              <br data-id="element-43" />
              En menos de 24 horas de haberla publicado.
            </p>
            <p className="text-white font-medium drop-shadow-[0_2px_4px_rgba(0,0,0,0.8)]" data-id="element-44">
              Ese día entendí que esto era un negocio real. No un hobby. Un
              negocio.
            </p>
            <p className="text-white font-medium drop-shadow-[0_2px_4px_rgba(0,0,0,0.8)]" data-id="element-45">
              Hoy ese sistema completo está dentro de este pack. Cada error que
              cometí es una página que te ahorra meses de frustración y plata
              tirada.
            </p>
          </div>
        </div>
      </section>

      {/* SECCIÓN 5 — QUÉ HACE DIFERENTE A ESTE MÉTODO */}
      <section className="py-16 md:py-24 px-4 bg-[#0A0A0A]" data-id="element-46">
        <div className="max-w-3xl mx-auto" data-id="element-47">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-white mb-12" data-id="element-48">
            Por qué otros métodos te dejan a mitad de camino
          </h2>

          {/* Column headers */}
          <div className="grid grid-cols-[1fr_auto_auto_auto] gap-x-2 sm:gap-x-4 items-end mb-4 px-2" data-id="element-49">
            <div data-id="element-50"></div>
            <div className="text-center text-[10px] sm:text-xs text-[#C8B89A] w-14 sm:w-20" data-id="element-51">
              YouTube / Blogs
            </div>
            <div className="text-center text-[10px] sm:text-xs text-[#C8B89A] w-14 sm:w-20" data-id="element-52">
              Cursos genéricos
            </div>
            <div className="text-center text-[10px] sm:text-xs text-[#D4A843] font-bold w-14 sm:w-20" data-id="element-53">
              Madera Cero
            </div>
          </div>

          {/* Feature rows */}
          <div className="space-y-2" data-id="element-54">
            {['Pasos completos de A a Z', 'Enfocado en vender, no solo hacer', 'Sistema de ventas por WhatsApp', 'Calculadora de costos y precios', 'Plantillas listas para usar', 'Adaptado a Latinoamérica 2026', 'Acceso de por vida'].map((feature, idx) => <div key={idx} className="grid grid-cols-[1fr_auto_auto_auto] gap-x-2 sm:gap-x-4 items-center bg-[#111111] border border-[#2A1F0A] rounded-lg px-3 py-3 sm:px-4" data-id="element-55">
                <span className="text-white text-sm sm:text-base" data-id="element-56">
                  {feature}
                </span>
                <div className="w-14 sm:w-20 flex justify-center" data-id="element-57">
                  <XCircle className="w-5 h-5 text-red-500/50" data-id="element-58" />
                </div>
                <div className="w-14 sm:w-20 flex justify-center" data-id="element-59">
                  <XCircle className="w-5 h-5 text-red-500/50" data-id="element-60" />
                </div>
                <div className="w-14 sm:w-20 flex justify-center bg-[#1C1208] rounded py-1" data-id="element-61">
                  <CheckCircle2 className="w-5 h-5 text-[#D4A843]" data-id="element-62" />
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* SECCIÓN 6 — PRESENTACIÓN DEL PRODUCTO */}
      <section className="py-16 md:py-24 px-4 bg-[#111111] border-y border-[#2A1F0A]" data-id="element-63">
        <div className="max-w-4xl mx-auto text-center" data-id="element-64">
          <p className="text-[#C8B89A] uppercase tracking-widest mb-4" data-id="element-65">
            Presentamos:
          </p>
          <h2 className="text-4xl md:text-5xl font-extrabold text-[#D4A843] mb-4" data-id="element-66">
            EL MÉTODO MADERA CERO
          </h2>
          <p className="text-xl text-white mb-8" data-id="element-67">
            Pack Completo · Edición Premium 2026
          </p>

          <p className="text-lg md:text-xl text-[#C8B89A] max-w-2xl mx-auto mb-12 leading-relaxed" data-id="element-68">
            El sistema paso a paso para transformar pallets en muebles de diseño
            premium y venderlos desde tu celular.
            <br data-id="element-69" />
            <span className="text-white font-bold mt-4 block" data-id="element-70">
              Sin taller propio. Sin experiencia previa. Sin inversión inicial
              de riesgo.
            </span>
          </p>

          {/* Product Mockup Image */}
          <div className="w-full max-w-3xl mx-auto rounded-xl overflow-hidden shadow-[0_0_50px_rgba(212,168,67,0.15)]" data-id="element-71">
            <img src="https://cdn.magicpatterns.com/uploads/6TBgNhbhfmnF3EZ1fHSj3J/mockup_idea_1.png" alt="El Método Madera Cero - Pack Completo con todos los libros y bonus" className="w-full h-auto" data-id="element-72" />
          </div>
        </div>
      </section>

      {/* SECCIÓN 7 — LO QUE RECIBÍS (OFFER STACK) */}
      <section className="py-16 md:py-24 px-4 bg-[#0A0A0A]" data-id="element-73">
        <div className="max-w-5xl mx-auto" data-id="element-74">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-white mb-16 uppercase tracking-wider" data-id="element-75">
            TODO LO QUE INCLUYE EL PACK:
          </h2>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-16" data-id="element-76">
            {/* Libro Maestro */}
            <div className="lg:col-span-3 bg-gradient-to-r from-[#1C1208] to-[#111111] border border-[#D4A843] rounded-xl p-8 flex flex-col md:flex-row gap-8 items-center shadow-lg" data-id="element-77">
              <div className="w-24 h-32 bg-[#0A0A0A] border border-[#2A1F0A] rounded flex-shrink-0 flex items-center justify-center" data-id="element-78">
                <BookOpen className="w-12 h-12 text-[#D4A843]" data-id="element-79" />
              </div>
              <div className="flex-1 text-center md:text-left" data-id="element-80">
                <div className="inline-block bg-[#D4A843]/20 text-[#D4A843] px-3 py-1 rounded-full text-sm font-bold mb-3" data-id="element-81">
                  LIBRO MAESTRO
                </div>
                <h3 className="text-2xl font-bold text-white mb-2" data-id="element-82">
                  EL MÉTODO MADERA CERO
                </h3>
                <p className="text-[#D4A843] italic mb-4" data-id="element-83">
                  "Muebles de Lujo con Pallets"
                </p>
                <p className="text-[#C8B89A] mb-4" data-id="element-84">
                  La guía madre. El sistema completo de principio a fin — desde
                  conseguir el pallet hasta cobrar tu primera venta.
                </p>
                <p className="text-white font-bold" data-id="element-85">
                  Valor individual:{' '}
                  <span className="line-through text-gray-500 mr-2" data-id="element-86">
                    $47 USD
                  </span>{' '}
                  <span className="text-[#00FF00]" data-id="element-87">✓ INCLUIDO</span>
                </p>
              </div>
            </div>

            {/* Tomos 1-6 */}
            {[{
            title: 'TOMO 1 — LA GUÍA DEL SELECTOR',
            icon: <Package className="w-8 h-8 text-[#D4A843]" data-id="element-88" />,
            desc: 'Cómo identificar, conseguir y seleccionar los mejores pallets (muchos gratis o casi gratis). Qué madera sirve, cuál descartar y por qué.',
            val: '$27'
          }, {
            title: 'TOMO 2 — EL ARSENAL DEL PRINCIPIANTE',
            icon: <Wrench className="w-8 h-8 text-[#D4A843]" data-id="element-89" />,
            desc: 'Las únicas herramientas que realmente necesitás. Lista de compras para arrancar con menos de $80 USD. Dónde comprarlas más baratas en tu país.',
            val: '$27'
          }, {
            title: 'TOMO 3 — ACABADOS DE ESPEJO',
            icon: <Paintbrush className="w-8 h-8 text-[#D4A843]" data-id="element-90" />,
            desc: 'El secreto para que tu mueble de pallet parezca comprado en una tienda de diseño de $2.000. Técnicas de tinte, barniz y sellado paso a paso.',
            val: '$27'
          }, {
            title: 'TOMO 4 — EL DISEÑO HÍBRIDO',
            icon: <Layers className="w-8 h-8 text-[#D4A843]" data-id="element-91" />,
            desc: 'Cómo combinar pallet con metal, vidrio y otros materiales para crear piezas únicas de alto valor. Los diseños que más se venden hoy en 2026.',
            val: '$27'
          }, {
            title: 'TOMO 5 — UNIONES OCULTAS',
            icon: <LinkIcon className="w-8 h-8 text-[#D4A843]" data-id="element-92" />,
            desc: 'La técnica para ensamblar sin tornillos visibles. Tus muebles van a lucir como obra de un maestro carpintero con 20 años de experiencia.',
            val: '$27'
          }, {
            title: 'TOMO 6 — WHATSAPP PROFIT SYSTEM',
            icon: <MessageCircle className="w-8 h-8 text-[#D4A843]" data-id="element-93" />,
            desc: 'El sistema para vender tus muebles por WhatsApp en menos de 24 horas. Fotos, textos y estrategia completa para convertir chats en ventas reales.',
            val: '$27'
          }].map((tomo, idx) => <div key={idx} className="bg-[#111111] border border-[#2A1F0A] rounded-xl p-6 flex flex-col h-full hover:border-[#D4A843]/50 transition-colors" data-id="element-94">
                <div className="mb-4" data-id="element-95">{tomo.icon}</div>
                <h3 className="text-lg font-bold text-white mb-3" data-id="element-96">
                  {tomo.title}
                </h3>
                <p className="text-[#C8B89A] text-sm flex-1 mb-4" data-id="element-97">
                  {tomo.desc}
                </p>
                <div className="pt-4 border-t border-[#2A1F0A] mt-auto" data-id="element-98">
                  <p className="text-white text-sm font-bold" data-id="element-99">
                    Valor:{' '}
                    <span className="line-through text-gray-500 mr-2" data-id="element-100">
                      {tomo.val} USD
                    </span>{' '}
                    <span className="text-[#00FF00]" data-id="element-101">✓ INCLUIDO</span>
                  </p>
                </div>
              </div>)}

            {/* Bonus 1-3 */}
            {[{
            title: 'BONUS #1 — LISTAS DE CORTE EXPRESS',
            icon: <FileText className="w-8 h-8 text-[#FF8C00]" data-id="element-102" />,
            desc: '12 proyectos con todas las medidas y cortes ya calculados. Imprimí la lista, cortá y armá.',
            val: '$17'
          }, {
            title: 'BONUS #2 — BIBLIOTECA DE PLANTILLAS 1:1',
            icon: <Layers className="w-8 h-8 text-[#FF8C00]" data-id="element-103" />,
            desc: '19 plantillas técnicas imprimibles en escala real. Llevá la plantilla al taller y que te corten exacto.',
            val: '$17'
          }, {
            title: 'BONUS #3 — CALCULADORA DE COSTOS & PRECIOS',
            icon: <Calculator className="w-8 h-8 text-[#FF8C00]" data-id="element-104" />,
            desc: 'La hoja de cálculo para saber exactamente cuánto cobrar por cada mueble y nunca más regalar tu trabajo.',
            val: '$17'
          }].map((bonus, idx) => <div key={idx} className="bg-[#1C1208] border border-[#FF8C00]/30 rounded-xl p-6 flex flex-col h-full relative overflow-hidden" data-id="element-105">
                <div className="absolute top-0 right-0 bg-[#FF8C00] text-[#0A0A0A] text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-106">
                  REGALO
                </div>
                <div className="mb-4" data-id="element-107">{bonus.icon}</div>
                <h3 className="text-lg font-bold text-[#FF8C00] mb-3" data-id="element-108">
                  {bonus.title}
                </h3>
                <p className="text-[#C8B89A] text-sm flex-1 mb-4" data-id="element-109">
                  {bonus.desc}
                </p>
                <div className="pt-4 border-t border-[#2A1F0A] mt-auto" data-id="element-110">
                  <p className="text-white text-sm font-bold" data-id="element-111">
                    Valor:{' '}
                    <span className="line-through text-gray-500 mr-2" data-id="element-112">
                      {bonus.val} USD
                    </span>{' '}
                    <span className="text-[#00FF00]" data-id="element-113">✓ GRATIS</span>
                  </p>
                </div>
              </div>)}
          </div>

          {/* Resumen de Valor */}
          <div className="max-w-md mx-auto bg-[#111111] border-2 border-[#D4A843] rounded-xl p-8 shadow-[0_0_30px_rgba(212,168,67,0.1)]" data-id="element-114">
            <h3 className="text-2xl font-bold text-center text-white mb-6" data-id="element-115">
              RESUMEN DE VALOR
            </h3>
            <div className="space-y-3 text-lg mb-6 border-b border-[#2A1F0A] pb-6" data-id="element-116">
              <div className="flex justify-between text-[#C8B89A]" data-id="element-117">
                <span data-id="element-118">Libro Maestro:</span>
                <span data-id="element-119">$47 USD</span>
              </div>
              <div className="flex justify-between text-[#C8B89A]" data-id="element-120">
                <span data-id="element-121">6 Tomos:</span>
                <span data-id="element-122">$162 USD</span>
              </div>
              <div className="flex justify-between text-[#C8B89A]" data-id="element-123">
                <span data-id="element-124">3 Bonus:</span>
                <span data-id="element-125">+$51 USD</span>
              </div>
            </div>
            <div className="flex justify-between items-center mb-6" data-id="element-126">
              <span className="text-xl text-white" data-id="element-127">VALOR TOTAL:</span>
              <span className="text-2xl font-bold text-red-500 line-through" data-id="element-128">
                $263 USD
              </span>
            </div>
            <div className="bg-[#1C1208] p-4 rounded-lg text-center mb-4" data-id="element-129">
              <span className="block text-[#C8B89A] text-sm uppercase tracking-wider mb-1" data-id="element-130">
                TU INVERSIÓN HOY:
              </span>
              <span className="text-4xl font-extrabold text-[#D4A843]" data-id="element-131">
                11.99 USD
              </span>
            </div>
            <div className="text-center text-[#00FF00] font-bold text-lg" data-id="element-132">
              AHORRÁS: +$251 USD
            </div>
          </div>
        </div>
      </section>

      {/* SECCIÓN 8 — INTERIOR DEL PRODUCTO */}
      <section className="py-16 md:py-24 px-4 bg-[#111111] border-y border-[#2A1F0A]" data-id="element-133">
        <div className="max-w-6xl mx-auto" data-id="element-134">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-white mb-16" data-id="element-135">
            Un vistazo a lo que hay adentro:
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-id="element-136">
            {/* Imagen 1 — con foto real */}
            <div className="bg-[#1C1208] rounded-xl overflow-hidden border border-[#2A1F0A] group" data-id="element-137">
              <div className="h-48 bg-[#0A0A0A] border-b border-[#2A1F0A] overflow-hidden" data-id="element-138">
                <img src="https://cdn.magicpatterns.com/uploads/sDwSbNauSLN9fwwtaH7m7y/Captura_de_pantalla_2026-03-26_175559.png" alt="Interior página del Libro Maestro - Anatomía del Sello IPPC" className="w-full h-full object-cover" data-id="element-139" />
              </div>
              <div className="p-4 text-center" data-id="element-140">
                <p className="text-[#D4A843] text-sm italic" data-id="element-141">
                  Ejemplo de página con proceso de selección de pallet
                </p>
              </div>
            </div>

            {/* Imágenes 2-5 — placeholders */}
            {/* Imagen 2 — con foto real */}
            <div className="bg-[#1C1208] rounded-xl overflow-hidden border border-[#2A1F0A] group" data-id="element-142">
              <div className="h-48 bg-[#0A0A0A] border-b border-[#2A1F0A] overflow-hidden" data-id="element-143">
                <img src="https://cdn.magicpatterns.com/uploads/hyjXaa6DuAjzDhXmHRJQzi/Captura_de_pantalla_2026-03-26_180351.png" alt="Interior Tomo 3 - El Proceso del Nogal Oscuro Satinado" className="w-full h-full object-cover" data-id="element-144" />
              </div>
              <div className="p-4 text-center" data-id="element-145">
                <p className="text-[#D4A843] text-sm italic" data-id="element-146">
                  Paso a paso de aplicación de barniz con fotos
                </p>
              </div>
            </div>

            {/* Imagen 3 — con foto real */}
            <div className="bg-[#1C1208] rounded-xl overflow-hidden border border-[#2A1F0A] group" data-id="element-147">
              <div className="h-48 bg-[#0A0A0A] border-b border-[#2A1F0A] overflow-hidden" data-id="element-148">
                <img src="https://cdn.magicpatterns.com/uploads/rEKZR1ksyGjAU3mqFWavgz/Captura_de_pantalla_2026-03-26_203306.png" alt="Interior Tomo 6 - El Guion Completo de WhatsApp, Mensajes 1 y 2" className="w-full h-full object-cover object-top" data-id="element-149" />
              </div>
              <div className="p-4 text-center" data-id="element-150">
                <p className="text-[#D4A843] text-sm italic" data-id="element-151">
                  Capturas de conversaciones de venta reales
                </p>
              </div>
            </div>

            {/* Imagen 4 — con foto real */}
            <div className="bg-[#1C1208] rounded-xl overflow-hidden border border-[#2A1F0A] group" data-id="element-152">
              <div className="h-48 bg-[#0A0A0A] border-b border-[#2A1F0A] overflow-hidden" data-id="element-153">
                <img src="https://cdn.magicpatterns.com/uploads/nFRQMJUisrdiqHCXJYBqhb/Captura_de_pantalla_2026-03-26_203820.png" alt="Bonus Calculadora - Hojas de Costo en Blanco para 6 Proyectos" className="w-full h-full object-cover object-top" data-id="element-154" />
              </div>
              <div className="p-4 text-center" data-id="element-155">
                <p className="text-[#D4A843] text-sm italic" data-id="element-156">
                  Vista de la hoja de cálculo de costos y precios
                </p>
              </div>
            </div>

            {/* Imagen 5 — con foto real */}
            <div className="bg-[#1C1208] rounded-xl overflow-hidden border border-[#2A1F0A] group" data-id="element-157">
              <div className="h-48 bg-[#0A0A0A] border-b border-[#2A1F0A] overflow-hidden" data-id="element-158">
                <img src="https://cdn.magicpatterns.com/uploads/v7vFJYa4GXmGqi2cdL7i75/Captura_de_pantalla_2026-03-26_220110.png" alt="Plantilla técnica con medidas para corte perfecto" className="w-full h-full object-cover object-top" data-id="element-159" />
              </div>
              <div className="p-4 text-center" data-id="element-160">
                <p className="text-[#D4A843] text-sm italic" data-id="element-161">
                  Plantilla para corte perfecto
                </p>
              </div>
            </div>
          </div>

          <p className="text-center text-xl text-white font-medium max-w-2xl mx-auto bg-[#1A1407] p-6 rounded-lg border border-[#D4A843]/20" data-id="element-162">
            Cada página está diseñada para que puedas tomar acción inmediata —
            no solo leer y guardar.
          </p>
        </div>
      </section>

      {/* SECCIÓN 9 — PARA QUIÉN ES (Y PARA QUIÉN NO) */}
      <section className="py-16 md:py-24 px-4 bg-[#0A0A0A]" data-id="element-163">
        <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-164">
          {/* Para quién SÍ es */}
          <div className="bg-[#111111] border border-[#2A1F0A] rounded-xl p-8" data-id="element-165">
            <h3 className="text-2xl font-bold text-white mb-8 flex items-center gap-3" data-id="element-166">
              <CheckCircle2 className="w-8 h-8 text-[#00FF00]" data-id="element-167" />
              ESTE PACK ES PARA VOS SI:
            </h3>
            <ul className="space-y-6" data-id="element-168">
              {['Querés un ingreso extra desde casa sin depender de un jefe o de un horario fijo', 'Tenés ganas de trabajar con las manos y crear algo tangible que tenga valor', 'Estás empezando desde cero y necesitás que alguien te explique todo paso a paso', 'Ya tenés algo de experiencia pero querés profesionalizar tus acabados y tus precios', 'Querés emprender con poca inversión inicial y un mercado que está creciendo en toda LATAM', 'Tenés entre 2 y 3 horas libres por día para dedicarle a tu nuevo proyecto'].map((item, idx) => <li key={idx} className="flex items-start gap-4" data-id="element-169">
                  <CheckCircle2 className="w-6 h-6 text-[#00FF00] flex-shrink-0 mt-1" data-id="element-170" />
                  <span className="text-[#C8B89A] text-lg" data-id="element-171">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* Para quién NO es */}
          <div className="bg-[#1C1208] border border-red-900/30 rounded-xl p-8" data-id="element-172">
            <h3 className="text-2xl font-bold text-white mb-8 flex items-center gap-3" data-id="element-173">
              <XCircle className="w-8 h-8 text-red-500" data-id="element-174" />
              ESTE PACK NO ES PARA VOS SI:
            </h3>
            <ul className="space-y-6" data-id="element-175">
              {['Buscás hacerte rico de la noche a la mañana sin poner ningún esfuerzo', 'No estás dispuesto a ensuciarte las manos y aprender haciendo', 'Querés resultados sin seguir el sistema'].map((item, idx) => <li key={idx} className="flex items-start gap-4" data-id="element-176">
                  <XCircle className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-177" />
                  <span className="text-[#C8B89A] text-lg" data-id="element-178">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </section>

      {/* SECCIÓN 10 — TESTIMONIOS */}
      <section className="py-16 md:py-24 px-4 bg-[#111111] border-y border-[#2A1F0A]" data-id="element-179">
        <div className="max-w-6xl mx-auto" data-id="element-180">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-white mb-16" data-id="element-181">
            Resultados Reales
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 gap-y-16" data-id="element-182">
            <TestimonialCard name="Rodrigo M." age={38} location="Buenos Aires, Argentina" quote="Arrancé sin saber ni cómo clavar un clavo. Seguí el Tomo 1 para conseguir los pallets (conseguí 6 gratis en una ferretería del barrio) y el Tomo 3 para los acabados. Mi primera mesa la vendí en $280 USD por WhatsApp. Mi señora no lo podía creer." result="Vendió su primera pieza a las 3 semanas de empezar" profilePlaceholder="Hombre 35 años, aspecto trabajador" workPlaceholder="Mesa ratona de pallet terminada" profileImage="https://cdn.magicpatterns.com/uploads/vN7QannHDLtLE2fanP5GLQ/imagen_para_perfil.jpg" workImage="https://cdn.magicpatterns.com/uploads/wSUo3BjRaLnQs3MUqFF26r/mesa_pallet.jpg" data-id="element-183" />
            <TestimonialCard name="Carolina V." age={43} location="Córdoba, Argentina" quote="Yo soy ama de casa y nunca había usado una sierra en mi vida. Con las plantillas del Bonus 2 y las listas de corte, le di las medidas al chico del corte y él me lo dejó todo listo. Solo tuve que armar, lijar y teñir. Vendo 2 o 3 piezas por mes y pago las expensas." result="Genera $400-600 USD por mes trabajando part-time" profilePlaceholder="Mujer 42 años, sonriendo" workPlaceholder="Estantería flotante de pallet con acabado oscuro" profileImage="https://cdn.magicpatterns.com/uploads/6G1zK9Mvd29mSJJx3Y9qvG/foto_de_perfil_mama_de_43_anos.jpg" workImage="https://cdn.magicpatterns.com/uploads/qUqeukBkG7VKEB85GXKX3m/estanteria_flotante_con_pallet.jpg" data-id="element-184" />
            <TestimonialCard name="Lucas T." age={29} location="Montevideo, Uruguay" quote="Ya tenía algo de experiencia con madera pero mis muebles no tenían el terminado que yo quería. El Tomo 5 de uniones ocultas fue un antes y un después. Y el sistema de WhatsApp del Tomo 6 me duplicó las ventas. Pasé de vender 1 pieza por mes a 4." result="Carpintero independiente desde 2023" profilePlaceholder="Hombre joven 28 años" workPlaceholder="Mesa industrial pallet + caño negro" profileImage="https://cdn.magicpatterns.com/uploads/2DAsVehEMrBAceiTv894rM/hombre_34_anos.jpg" workImage="https://cdn.magicpatterns.com/uploads/96fwFjaNQrK4EkP4ABC4ed/Mesa_industrial_pallet_2B_cano_negro.jpg" data-id="element-185" />
          </div>
        </div>
      </section>

      {/* SECCIÓN 11 — GARANTÍA */}
      <section className="py-16 md:py-24 px-4 bg-[#1A1407]" data-id="element-186">
        <div className="max-w-3xl mx-auto text-center" data-id="element-187">
          <ShieldCheck className="w-20 h-20 text-[#D4A843] mx-auto mb-6" data-id="element-188" />
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-8 uppercase tracking-wider" data-id="element-189">
            GARANTÍA TOTAL DE 7 DÍAS — SIN PREGUNTAS
          </h2>
          <div className="text-lg md:text-xl text-[#C8B89A] space-y-4 leading-relaxed" data-id="element-190">
            <p data-id="element-191">Tomá el pack. Leelo. Aplicalo.</p>
            <p data-id="element-192">
              Si en los próximos 7 días sentís que no era lo que esperabas, te
              devolvemos el 100% de tu dinero.
            </p>
            <p data-id="element-193">
              Sin formularios complicados. Sin justificaciones. Sin letra chica.
            </p>
            <p className="text-white font-bold mt-8" data-id="element-194">
              Confiamos tanto en este sistema que el riesgo es completamente
              nuestro, no tuyo. Tu única tarea es probarlo.
            </p>
          </div>
        </div>
      </section>

      {/* SECCIÓN 12 — OFERTA LIMITADA */}
      <section id="oferta" className="py-16 md:py-24 px-4 bg-[#0A0A0A] border-y border-[#D4A843]/30" data-id="element-195">
        <div className="max-w-4xl mx-auto" data-id="element-196">
          <div className="text-center mb-12" data-id="element-197">
            <div className="inline-block bg-[#FF8C00] text-[#0A0A0A] font-bold px-4 py-2 rounded-full mb-6 animate-pulse" data-id="element-198">
              🔥 OFERTA DE LANZAMIENTO — TIEMPO LIMITADO 🔥
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-199">
              Esta semana y solo esta semana, el pack completo está disponible
              al precio de lanzamiento.
            </h2>
            <CountdownTimer className="mb-12" data-id="element-200" />
          </div>

          <div className="bg-[#111111] border-2 border-[#D4A843] rounded-2xl p-6 md:p-10 shadow-[0_0_40px_rgba(212,168,67,0.15)]" data-id="element-201">
            <h3 className="text-2xl font-bold text-[#D4A843] mb-6 border-b border-[#2A1F0A] pb-4" data-id="element-202">
              LO QUE RECIBÍS HOY:
            </h3>

            <ul className="space-y-4 mb-8 text-lg" data-id="element-203">
              {[{
              name: 'Libro Maestro "Muebles de Lujo con Pallets"',
              price: '$47 USD',
              tag: 'INCLUIDO'
            }, {
              name: 'TOMO 1 — La Guía del Selector',
              price: '$27 USD',
              tag: 'INCLUIDO'
            }, {
              name: 'TOMO 2 — El Arsenal del Principiante',
              price: '$27 USD',
              tag: 'INCLUIDO'
            }, {
              name: 'TOMO 3 — Acabados de Espejo',
              price: '$27 USD',
              tag: 'INCLUIDO'
            }, {
              name: 'TOMO 4 — El Diseño Híbrido',
              price: '$27 USD',
              tag: 'INCLUIDO'
            }, {
              name: 'TOMO 5 — Uniones Ocultas',
              price: '$27 USD',
              tag: 'INCLUIDO'
            }, {
              name: 'TOMO 6 — WhatsApp Profit System',
              price: '$27 USD',
              tag: 'INCLUIDO'
            }].map((item, idx) => <li key={idx} className="flex flex-col sm:flex-row sm:items-center justify-between gap-2" data-id="element-204">
                  <span className="flex items-center gap-2 text-white" data-id="element-205">
                    <CheckCircle2 className="w-5 h-5 text-[#D4A843]" data-id="element-206" />{' '}
                    {item.name}
                  </span>
                  <span className="text-[#C8B89A] text-sm sm:text-base" data-id="element-207">
                    <span className="line-through mr-2" data-id="element-208">{item.price}</span> →{' '}
                    <span className="text-[#00FF00] font-bold" data-id="element-209">{item.tag}</span>
                  </span>
                </li>)}

              {[{
              name: 'BONUS #1 — Listas de Corte Express',
              price: '$17 USD'
            }, {
              name: 'BONUS #2 — Biblioteca de Plantillas 1:1',
              price: '$17 USD'
            }, {
              name: 'BONUS #3 — Calculadora de Costos & Precios',
              price: '$17 USD'
            }].map((item, idx) => <li key={idx} className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 bg-[#1C1208] p-2 rounded" data-id="element-210">
                  <span className="flex items-center gap-2 text-[#FF8C00] font-bold" data-id="element-211">
                    🎁 {item.name}
                  </span>
                  <span className="text-[#C8B89A] text-sm sm:text-base" data-id="element-212">
                    <span className="line-through mr-2" data-id="element-213">{item.price}</span> →{' '}
                    <span className="text-[#00FF00] font-bold" data-id="element-214">GRATIS</span>
                  </span>
                </li>)}
            </ul>

            <div className="border-y-2 border-dashed border-[#2A1F0A] py-6 my-6 text-center" data-id="element-215">
              <p className="text-xl text-[#C8B89A] mb-2" data-id="element-216">
                VALOR TOTAL DEL PACK:{' '}
                <span className="line-through" data-id="element-217">$263 USD</span>
              </p>
              <p className="text-sm text-white uppercase tracking-widest mb-2" data-id="element-218">
                PRECIO DE LANZAMIENTO:
              </p>
              <p className="text-5xl md:text-6xl font-extrabold text-[#D4A843]" data-id="element-219">
                11.99 USD
              </p>
            </div>

            {/* Mockup Image */}
            <div className="w-full max-w-lg mx-auto mb-8 rounded-xl overflow-hidden" data-id="element-220">
              <img src="https://cdn.magicpatterns.com/uploads/75oaecNxAmRUoJjeWMii92/mockup_idea_1.png" alt="Pack completo El Método Madera Cero - Todos los tomos y bonus" className="w-full h-auto" data-id="element-221" />
            </div>

            <CTAButton href="https://pay.hotmart.com/B105112598W?checkoutMode=10" className="text-sm md:text-base py-2 px-6 mb-6 flex-col gap-1" data-id="element-222">
              <span data-id="element-223">🔨 SÍ, QUIERO EL PACK COMPLETO AHORA →</span>
              <div className="flex flex-wrap justify-center gap-x-4 gap-y-1 text-sm font-normal text-[#1A1407] opacity-80" data-id="element-224">
                <span data-id="element-225">✓ Acceso inmediato</span>
                <span data-id="element-226">✓ Garantía 7 días</span>
                <span data-id="element-227">✓ Pago único</span>
                <span data-id="element-228">✓ Sin suscripción</span>
              </div>
            </CTAButton>

            <div className="flex flex-col items-center gap-4" data-id="element-229">
              <div className="flex gap-4 opacity-50" data-id="element-230">
                {/* Payment Icons Placeholders */}
                <div className="w-12 h-8 bg-white/10 rounded flex items-center justify-center text-[10px]" data-id="element-231">
                  Visa
                </div>
                <div className="w-12 h-8 bg-white/10 rounded flex items-center justify-center text-[10px]" data-id="element-232">
                  Master
                </div>
                <div className="w-12 h-8 bg-white/10 rounded flex items-center justify-center text-[10px]" data-id="element-233">
                  PayPal
                </div>
                <div className="w-12 h-8 bg-white/10 rounded flex items-center justify-center text-[10px]" data-id="element-234">
                  MP
                </div>
              </div>
              <p className="flex items-center gap-2 text-sm text-[#C8B89A]" data-id="element-235">
                <Lock className="w-4 h-4" data-id="element-236" /> Pago 100% seguro y encriptado
              </p>
              <p className="text-sm text-[#C8B89A]" data-id="element-237">
                Pagas en la moneda de tu país
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* SECCIÓN 13 — FAQ */}
      <section className="py-16 md:py-24 px-4 bg-[#111111]" data-id="element-238">
        <div className="max-w-3xl mx-auto" data-id="element-239">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-white mb-12 uppercase tracking-wider" data-id="element-240">
            PREGUNTAS FRECUENTES
          </h2>

          <div className="space-y-4" data-id="element-241">
            <FAQItem question="¿Necesito experiencia previa en carpintería?" answer="Para nada. El método empieza desde cero absoluto. Si podés sostener un destornillador, podés seguirlo." data-id="element-242" />
            <FAQItem question="¿Qué herramientas necesito para empezar?" answer="El Tomo 2 detalla exactamente qué necesitás. La lista básica para arrancar cuesta menos de $80 USD." data-id="element-243" />
            <FAQItem question="¿Puedo hacerlo sin taller propio?" answer="Sí. La mayoría empieza en el garaje, el patio o incluso pidiendo prestado un espacio." data-id="element-244" />
            <FAQItem question="¿En cuánto tiempo puedo hacer mi primera venta?" answer="Siguiendo el sistema, la mayoría logra su primera venta entre la semana 2 y la semana 4." data-id="element-245" />
            <FAQItem question="¿El contenido está en formato PDF?" answer="Sí. Acceso digital inmediato. Podés leerlo en celular, tablet o computadora. Sin apps adicionales." data-id="element-246" />
            <FAQItem question="¿Tiene actualizaciones?" answer="Sí. Esta es la Edición 2026 y las actualizaciones son incluidas sin costo adicional." data-id="element-247" />
            <FAQItem question="¿Cómo funciona la garantía?" answer="Si en 7 días no estás satisfecho, escribinos y te devolvemos el 100% sin preguntas." data-id="element-248" />
            <FAQItem question="¿Puedo vender en cualquier país de Latinoamérica?" answer="Absolutamente. El método está diseñado y probado para Argentina, México, Chile, Uruguay, Colombia y toda la región hispanohablante." data-id="element-249" />
          </div>
        </div>
      </section>

      {/* SECCIÓN 14 — CTA FINAL */}
      <section className="py-20 md:py-32 px-4 bg-[#0A0A0A] relative overflow-hidden" data-id="element-250">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(212,168,67,0.1)_0%,transparent_70%)]" data-id="element-251"></div>

        <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-252">
          <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-10 leading-tight" data-id="element-253">
            ¿Vas a seguir mirando muebles que otros venden o vas a empezar a
            armar los tuyos?
          </h2>

          <div className="text-xl text-[#C8B89A] space-y-4 mb-12 max-w-2xl mx-auto" data-id="element-254">
            <p data-id="element-255">
              Cada día que pasa sin el sistema es un día más trabajando para el
              ingreso de otro.
            </p>
            <p data-id="element-256">Los pallets siguen tirados en la vereda.</p>
            <p data-id="element-257">Los compradores siguen buscando en Instagram.</p>
            <p data-id="element-258">El mercado sigue creciendo.</p>
            <p className="text-2xl text-[#D4A843] font-bold mt-8" data-id="element-259">
              La única pregunta es:
              <br data-id="element-260" />
              ¿cuándo vas a dar el primer paso?
            </p>
          </div>

          <CountdownTimer compact className="text-2xl text-[#FF8C00] mb-8" data-id="element-261" />

          <div className="flex justify-center mb-16" data-id="element-262">
            <CTAButton href="https://pay.hotmart.com/B105112598W?checkoutMode=10" className="text-base md:text-lg py-3 px-6 flex-col gap-1" data-id="element-263">
              <span data-id="element-264">🔨 ACCEDER AL MÉTODO MADERA CERO AHORA →</span>
              <span className="text-sm font-normal text-[#1A1407] opacity-80" data-id="element-265">
                Precio de lanzamiento — Solo por tiempo limitado
              </span>
            </CTAButton>
          </div>
        </div>
      </section>

      {/* PIE DE PÁGINA */}
      <footer className="bg-[#0A0A0A] border-t border-[#2A1F0A] py-8 px-4 text-center text-[#C8B89A] text-sm" data-id="element-266">
        <div className="max-w-4xl mx-auto" data-id="element-267">
          <p className="mb-4" data-id="element-268">
            © 2026 El Método Madera Cero · Todos los derechos reservados
          </p>
          <div className="flex flex-wrap justify-center gap-4 md:gap-8 mb-6" data-id="element-269">
            <a href="#" className="hover:text-[#D4A843] transition-colors" data-id="element-270">
              Política de privacidad
            </a>
            <a href="#" className="hover:text-[#D4A843] transition-colors" data-id="element-271">
              Términos y condiciones
            </a>
            <a href="#" className="hover:text-[#D4A843] transition-colors" data-id="element-272">
              Contacto
            </a>
          </div>
          <p className="flex items-center justify-center gap-2 opacity-50" data-id="element-273">
            <Lock className="w-3 h-3" data-id="element-274" /> Sitio seguro · Powered by Hotmart
          </p>
        </div>
      </footer>
    </div>;
}